module.exports = __webpack_public_path__ + "static/5-6dbc79eef335ba11ac581bdce9d10389.jpg";